// Auto-generated catalog translations (en). Base content: Portuguese. Review before editing by hand.
export default {
    experiences: {
      "north-tour-cocoa-route": {
        "name": "North Tour & Cocoa Route",
        "category": "Culture & Nature",
        "cats": ["Experiences", "Culture", "Nature"],
        "duration": "Full Day",
        "location": "Northern São Tomé",
        "meetingPoint": "Pick-up at accommodation (São Tomé city)",
        "groupSize": "Private or small group",
        "overview": "A journey through the cocoa heritage, historic roças, fishing communities, beaches, and landscapes of northern São Tomé.",
        "highlights": ["Historic cocoa roças", "Fishing communities", "Northern beaches and viewpoints"],
        "included": ["Local guide", "Transport", "Eco Collection support"],
        "notIncluded": ["Lunch (unless specified)", "Personal expenses"],
        "bring": ["Comfortable footwear", "Water", "Sunscreen"],
      },
      "wild-south-pico-cao-grande": {
        "name": "Wild South & Pico Cão Grande",
        "category": "Nature & Island Discovery",
        "cats": ["Experiences", "Nature"],
        "duration": "Full Day",
        "location": "Southern São Tomé",
        "meetingPoint": "Pick-up at accommodation",
        "groupSize": "Private or small group",
        "overview": "The wild south of São Tomé: the imposing Pico Cão Grande, the southern coast, tropical landscapes, and communities living between the forest and the sea.",
        "highlights": ["Pico Cão Grande", "Wild southern coast", "Local communities"],
        "included": ["Local guide", "Transport"],
        "notIncluded": ["Lunch (unless specified)"],
        "bring": ["Comfortable footwear", "Water", "Sunscreen"],
      },
      "ilheu-santana-by-boat": {
        "name": "Ilhéu Santana by Boat",
        "category": "Sea & Nature",
        "cats": ["Experiences", "Sea", "Nature"],
        "duration": "Half Day",
        "location": "East Coast, São Tomé",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Small group",
        "overview": "A maritime experience along the eastern coast of São Tomé to Ilhéu Santana, featuring volcanic landscapes and stops for swimming.",
        "highlights": ["Ilhéu Santana", "Volcanic coast", "Swimming in crystal-clear waters"],
        "included": ["Boat", "Local guide"],
        "notIncluded": ["Snorkeling equipment (unless specified)"],
        "bring": ["Swimsuit", "Towel", "Sunscreen"],
      },
      "discover-principe": {
        "name": "Discover Príncipe: Roças, História & Praia Banana",
        "category": "Culture, Nature & History",
        "cats": ["Experiences", "Culture", "Nature"],
        "duration": "± 09:00–17:00/18:00",
        "location": "Príncipe Island",
        "meetingPoint": "Santo António",
        "groupSize": "Guided tour, mainly by car",
        "overview": "The essentials of Príncipe in one day: agriculture and heritage of the roças, iconic beaches, local communities, and a local glass transformation and recycling initiative.",
        "highlights": ["Roça Paciência and Roça Belo Monte", "Praia Banana", "Local glass recycling initiative"],
        "included": ["Guide", "Vehicle", "Fuel", "Lunch"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Comfortable footwear", "Water", "Sunscreen"],
      },
      "principe-biosphere": {
        "name": "Príncipe Biosphere: Trails, Waterfalls & Communities",
        "category": "Hiking, Nature & Community",
        "cats": ["Experiences", "Nature"],
        "duration": "Full Day",
        "location": "Biosphere Reserve, Príncipe",
        "meetingPoint": "Santo António",
        "groupSize": "Small group",
        "overview": "Dense forest, waterfalls, natural pools, native and medicinal plants, local communities, fishing culture, and artisanal soap production.",
        "highlights": ["Ôquê Pipi Waterfall", "Natural pools", "Fishing communities and culture"],
        "included": ["Guide", "Vehicle", "Fuel", "Lunch", "Natural park fee, when applicable"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Hiking shoes", "Water", "Insect repellent"],
      },
      "principe-by-sea": {
        "name": "Príncipe by Sea: Coast, Caves & Marine Life",
        "category": "Sea & Nature",
        "cats": ["Experiences", "Sea", "Nature"],
        "duration": "± 09:00–15:00/16:00",
        "location": "Príncipe Coast",
        "meetingPoint": "Baía de Santo António",
        "groupSize": "Small group",
        "overview": "A boat tour along the coast of Príncipe: rock formations, caves, swimming, possible snorkeling, fishing communities, and lunch by the sea, returning to Baía de Santo António. Possible sightings of turtles, dolphins, whales, and fish depending on the season and natural conditions — sightings not guaranteed.",
        "highlights": ["Caves and rock formations", "Possible snorkeling", "Lunch by the sea"],
        "included": ["Boat", "Local guide", "Lunch by the sea"],
        "notIncluded": ["Snorkeling equipment (unless specified)"],
        "bring": ["Swimsuit", "Towel", "Sunscreen"],
      },
      "santiago-grand-island-tour": {
        "name": "Santiago Grand Island Tour",
        "category": "Island Discovery",
        "cats": ["Experiences", "Culture", "Nature"],
        "duration": "8h",
        "location": "Santiago Island",
        "meetingPoint": "Hotel pick-up ± 08:45",
        "groupSize": "Private or small group",
        "overview": "Northern and southern Santiago in a full day: the most African island of Cabo Verde, surrounded by mountains, valleys, history, and Creole culture.",
        "highlights": ["North and South of the island", "Mountain landscapes", "Creole culture"],
        "included": ["Private transport", "Lunch", "1 bottle of water per person"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Comfortable footwear", "Sunscreen"],
      },
      "authentic-northern-santiago": {
        "name": "Authentic Northern Santiago",
        "category": "Culture & Local Life",
        "cats": ["Experiences", "Culture"],
        "duration": "± 09:00–14:00",
        "location": "Northern Santiago",
        "meetingPoint": "Pick-up at accommodation",
        "groupSize": "Small group",
        "overview": "Local life in northern Santiago: the Vale de Principal, the Rabelados community in Espinho Branco, banana plantations in Santa Cruz, the Assomada Municipal Market, and a photo stop at the Serra Malagueta viewpoint.",
        "highlights": ["Rabelados community", "Assomada Market", "Banana plantations"],
        "included": ["Transport", "Lunch", "Water"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Comfortable footwear", "Camera"],
      },
      "traditional-fishing-beach-bbq": {
        "name": "Traditional Fishing & Private Beach BBQ",
        "category": "Sea, Fishing & Gastronomy",
        "cats": ["Experiences", "Sea", "Gastronomy"],
        "duration": "Half/Full Day",
        "location": "Tarrafal, Santiago",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Private",
        "overview": "Traditional boat trip, artisanal fishing, sea bathing, and preparing the caught fish for a BBQ/lunch on a beach. Optional Praia ↔ Tarrafal transport according to the chosen option.",
        "highlights": ["Artisanal fishing", "Beach BBQ", "Traditional boat"],
        "included": ["Traditional boat", "Lunch/BBQ", "Local guide"],
        "notIncluded": ["Praia ↔ Tarrafal transport (depending on option)"],
        "bring": ["Swimsuit", "Towel", "Sunscreen"],
      },
      "tarrafal-boat-swimming": {
        "name": "Tarrafal Traditional Boat & Swimming",
        "category": "Sea",
        "cats": ["Experiences", "Sea"],
        "duration": "Half Day",
        "location": "Tarrafal, Santiago",
        "meetingPoint": "Baía do Tarrafal",
        "groupSize": "Small group",
        "overview": "A traditional boat ride along the Tarrafal coast with an opportunity to swim in the calm waters of the bay.",
        "highlights": ["Tarrafal coast", "Sea swimming", "Traditional boat"],
        "included": ["Traditional boat", "Local guide"],
        "notIncluded": ["Transport to Tarrafal"],
        "bring": ["Swimsuit", "Towel"],
      },
      "cachupa-cooking": {
        "name": "Cape Verdean Cachupa Cooking Experience",
        "category": "Food & Culture",
        "cats": ["Experiences", "Gastronomy", "Culture"],
        "duration": "Half Day",
        "location": "Santiago",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Small group",
        "overview": "A hands-on experience preparing cachupa, the Cape Verdean national dish, followed by a tasting in a local setting.",
        "highlights": ["Cachupa preparation", "Tasting", "Local culture"],
        "included": ["Ingredients", "Tasting", "Local host"],
        "notIncluded": ["Transport (unless specified)"],
        "bring": ["Appetite"],
      },
      "serra-malagueta-vale-principal-trek": {
        "name": "Serra Malagueta → Vale de Principal Trek",
        "category": "Hiking & Nature",
        "cats": ["Experiences", "Nature"],
        "duration": "± 2h45",
        "location": "Serra Malagueta, Santiago",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Small group",
        "overview": "Trekking from Serra Malagueta to Vale de Principal, through green valleys and mountain villages.",
        "highlights": ["Serra Malagueta", "Vale de Principal", "Mountain villages"],
        "included": ["Transport", "Guide", "Lunch", "Entrance fee"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Hiking shoes", "Water", "Hat", "Sunscreen", "Sunglasses"],
      },
      "serra-malagueta-mato-brasil-trek": {
        "name": "Serra Malagueta → Mato Brasil Trek",
        "category": "Hiking & Nature",
        "cats": ["Experiences", "Nature"],
        "duration": "± 3h",
        "location": "Serra Malagueta, Santiago",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Small group",
        "overview": "A more demanding trek from Serra Malagueta to Mato Brasil. Recommended for physically active people or those with mountain experience.",
        "highlights": ["Demanding trail", "Mountain landscapes", "Endemic nature"],
        "included": ["Transport", "Guide", "Picnic"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Hiking shoes", "Water", "Hat", "Sunscreen"],
      },
      "pico-de-antonia-challenge": {
        "name": "Pico de Antónia Challenge",
        "category": "Hiking & Challenge",
        "cats": ["Experiences", "Nature"],
        "duration": "± 4–5h",
        "location": "Pico de Antónia, Santiago",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Small group",
        "overview": "Trekking to the highest point of Santiago island. Recommended for people in good physical condition with mountain hiking experience.",
        "highlights": ["Highest point of Santiago", "Mountain challenge", "Panoramic views"],
        "included": ["Private transport", "Guide", "Picnic, depending on the chosen configuration"],
        "notIncluded": ["Personal expenses"],
        "bring": ["Hiking shoes", "Water", "Hat", "Sunscreen", "Sweater"],
      },
      "santiago-community-ecotourism": {
        "name": "Santiago Community Ecotourism",
        "category": "Community & Ecotourism",
        "cats": ["Experiences", "Culture", "Nature"],
        "duration": "Half/Full Day",
        "location": "Interior of Santiago",
        "meetingPoint": "To be arranged after confirmation",
        "groupSize": "Small group",
        "overview": "Hiking and contact with local communities, including the possibility of visiting local homes, interaction, and traditional gastronomy. Final details depend on the configuration and partner.",
        "highlights": ["Local communities", "Traditional gastronomy", "Ecotourism"],
        "included": ["Local guide", "As per configuration"],
        "notIncluded": ["As per configuration"],
        "bring": ["Comfortable footwear", "Water"],
      },
    },
    packages: {
      "sao-tome-discovery": {
        "name": "São Tomé Discovery",
        "duration": "3 days",
        "style": "Short Stay",
        "idealFor": "First visit to São Tomé",
        "overview": "A perfect introduction to the island: arrival with transfer, the iconic Cocoa Route, and free time before departure.",
        "highlights": ["North Tour & Cocoa Route", "Airport transfer included", "Eco Collection local support"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival in São Tomé + airport transfer + check-in" },
          { "day": "Day 2", "text": "North Tour & Cocoa Route" },
          { "day": "Day 3", "text": "Free morning + departure transfer" },
        ],
        "accommodationNote": "Selected local accommodation, according to preference",
        "experiencesIncluded": ["North Tour & Cocoa Route"],
        "transfersNote": "Airport transfers included",
        "meals": "According to chosen accommodation",
        "included": ["Accommodation", "Airport transfer", "North Tour & Cocoa Route experience", "Local support"],
        "notIncluded": ["Flights", "Meals not mentioned", "Personal expenses"],
        "optional": ["Ilhéu Santana by Boat", "Wild South & Pico Cão Grande"],
        "important": ["Final price on request, according to season and preferences"],
      },
      "sao-tome-explorer": {
        "name": "São Tomé Explorer",
        "duration": "5 days",
        "style": "Island Explorer",
        "idealFor": "Those who want to see the essentials of the island",
        "overview": "Five days to explore São Tomé from north to south, with sea, cocoa, and the wild Pico Cão Grande.",
        "highlights": ["North and south of the island", "Ilhéu Santana", "Pico Cão Grande"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival & welcome" },
          { "day": "Day 2", "text": "North Tour & Cocoa Route" },
          { "day": "Day 3", "text": "Wild South & Pico Cão Grande" },
          { "day": "Day 4", "text": "Ilhéu Santana / selected experience" },
          { "day": "Day 5", "text": "Departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["North Tour & Cocoa Route", "Wild South & Pico Cão Grande", "Ilhéu Santana by Boat"],
        "transfersNote": "Airport transfers included",
        "meals": "According to chosen accommodation",
        "included": ["Accommodation", "Transfers", "Mentioned experiences", "Local support"],
        "notIncluded": ["Flights", "Meals not mentioned"],
        "optional": ["Local gastronomy experience"],
        "important": ["Final price on request"],
      },
      "sao-tome-complete": {
        "name": "São Tomé Complete",
        "duration": "8 days",
        "style": "Complete Island",
        "idealFor": "The most complete São Tomé experience",
        "overview": "The most comprehensive island experience, combining north, south, sea, culture, nature, and free time.",
        "highlights": ["North, south and sea", "Culture and gastronomy", "Free time for beaches"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival and settling in" },
          { "day": "Day 2", "text": "North Tour & Cocoa Route" },
          { "day": "Day 3", "text": "Wild South & Pico Cão Grande" },
          { "day": "Day 4", "text": "Ilhéu Santana by Boat" },
          { "day": "Day 5", "text": "Nature / waterfall" },
          { "day": "Day 6", "text": "Local culture & gastronomy" },
          { "day": "Day 7", "text": "Free day" },
          { "day": "Day 8", "text": "Departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["North Tour & Cocoa Route", "Wild South & Pico Cão Grande", "Ilhéu Santana by Boat", "Nature/waterfall experience", "Local culture & gastronomy"],
        "transfersNote": "Transfers included",
        "meals": "According to chosen accommodation",
        "included": ["Accommodation", "Transfers", "Mentioned experiences", "Local support"],
        "notIncluded": ["Flights", "Meals not mentioned"],
        "optional": ["Accommodation upgrades"],
        "important": ["Final price on request"],
      },
      "principe-essential": {
        "name": "Príncipe Essential",
        "duration": "3 days",
        "style": "Short Stay",
        "idealFor": "A taste of Príncipe",
        "overview": "The essentials of Príncipe island in three days: Santo António and the iconic roças tour up to Praia Banana.",
        "highlights": ["Discover Príncipe tour", "Praia Banana", "Santo António"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival + Santo António" },
          { "day": "Day 2", "text": "Discover Príncipe: Roças, History & Praia Banana" },
          { "day": "Day 3", "text": "Departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["Discover Príncipe: Roças, História & Praia Banana"],
        "transfersNote": "Local transfers included",
        "meals": "Lunch included in the tour",
        "included": ["Accommodation", "Local transfers", "Discover Príncipe", "Local support"],
        "notIncluded": ["Flights / São Tomé ↔ Príncipe connection", "Meals not mentioned"],
        "optional": ["Príncipe by Sea"],
        "important": ["Final price on request"],
      },
      "discover-principe-package": {
        "name": "Discover Príncipe",
        "duration": "5 days",
        "style": "Signature Island",
        "idealFor": "Three signature experiences. One island journey.",
        "overview": "Three signature experiences. A journey across the island: roças and history, biosphere and trails, and Príncipe seen from the sea.",
        "highlights": ["Roças & Praia Banana", "Biosphere & Trails", "Príncipe by Sea"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival + accommodation" },
          { "day": "Day 2", "text": "Roças, History & Praia Banana" },
          { "day": "Day 3", "text": "Biosphere, Trails, Waterfalls & Communities" },
          { "day": "Day 4", "text": "Príncipe by Sea" },
          { "day": "Day 5", "text": "Free morning + departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["Discover Príncipe", "Príncipe Biosphere", "Príncipe by Sea"],
        "transfersNote": "Local transfers included",
        "meals": "Lunches included in the experiences",
        "included": ["Accommodation", "Local transfers", "Three signature experiences", "Local support"],
        "notIncluded": ["Flights / São Tomé ↔ Príncipe connection"],
        "optional": ["Extra beach day"],
        "important": ["Final price on request"],
      },
      "stp-signature": {
        "name": "São Tomé & Príncipe Signature",
        "duration": "8 days",
        "style": "Two Islands",
        "idealFor": "Both islands in one trip",
        "overview": "The best of both islands: cocoa and the wild south in São Tomé, and the signature trio in Príncipe.",
        "highlights": ["Two islands", "Cocoa + Biosphere + Sea", "Continuous local support"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival in São Tomé" },
          { "day": "Day 2", "text": "North & Cocoa" },
          { "day": "Day 3", "text": "Wild South" },
          { "day": "Day 4", "text": "Transfer / flight to Príncipe" },
          { "day": "Day 5", "text": "Roças & Praia Banana" },
          { "day": "Day 6", "text": "Biosphere & Trails" },
          { "day": "Day 7", "text": "Príncipe by Sea / free time" },
          { "day": "Day 8", "text": "Departure" },
        ],
        "accommodationNote": "Local accommodations on both islands",
        "experiencesIncluded": ["North Tour & Cocoa Route", "Wild South & Pico Cão Grande", "Discover Príncipe", "Príncipe Biosphere", "Príncipe by Sea"],
        "transfersNote": "Transfers and inter-island connection coordinated by Eco Collection",
        "meals": "As per itinerary",
        "included": ["Accommodations", "Transfers", "Mentioned experiences", "Local support"],
        "notIncluded": ["International flights"],
        "optional": ["Accommodation upgrades"],
        "important": ["Final price on request"],
      },
      "stp-grand-journey": {
        "name": "STP Grand Journey",
        "duration": "10 days",
        "style": "Premium & Customisable",
        "idealFor": "Tailor-made premium trip",
        "overview": "Eco Collection's premium product: accommodation, transfers, multiple experiences, free time, local support, and optional upgrades — fully customizable.",
        "highlights": ["Fully customizable", "Premium", "Optional upgrades"],
        "itinerary": [
          { "day": "Day 1–4", "text": "São Tomé: north, south, sea and culture" },
          { "day": "Day 5", "text": "Connection to Príncipe" },
          { "day": "Day 6–9", "text": "Príncipe: roças, biosphere, sea and free time" },
          { "day": "Day 10", "text": "Departure" },
        ],
        "accommodationNote": "Accommodations selected with you",
        "experiencesIncluded": ["Tailor-made program"],
        "transfersNote": "All transfers coordinated",
        "meals": "As per itinerary",
        "included": ["Accommodations", "Transfers", "Combined experiences", "Dedicated local support"],
        "notIncluded": ["International flights"],
        "optional": ["Upgrades", "Extra experiences", "Additional nights"],
        "important": ["Personalized proposal on request"],
      },
      "santiago-essential": {
        "name": "Santiago Essential",
        "duration": "3 days",
        "style": "Short Stay",
        "idealFor": "Beach + culture + introduction to the island",
        "overview": "Beach, culture, and an introduction to Santiago island in three days.",
        "highlights": ["Cidade Velha", "Beach", "Creole culture"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival / transfer" },
          { "day": "Day 2", "text": "Cidade Velha / Southern region + local experience" },
          { "day": "Day 3", "text": "Departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["Local experience of choice"],
        "transfersNote": "Arrival transfer included",
        "meals": "According to accommodation",
        "included": ["Accommodation", "Arrival transfer", "Local experience", "Local support"],
        "notIncluded": ["Flights"],
        "optional": ["Cachupa Cooking Experience"],
        "important": ["Final price on request"],
      },
      "santiago-explorer": {
        "name": "Santiago Explorer",
        "duration": "5 days",
        "style": "Island Explorer",
        "idealFor": "Complete Santiago: beach, interior and north",
        "overview": "Beach, Cidade Velha, island interior, northern Santiago, Serra Malagueta / Tarrafal, and local culture in five days.",
        "highlights": ["Cidade Velha", "Interior + North", "Serra Malagueta / Tarrafal"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival" },
          { "day": "Day 2", "text": "Cidade Velha & Southern region" },
          { "day": "Day 3", "text": "Island interior" },
          { "day": "Day 4", "text": "Northern Santiago / Serra Malagueta / Tarrafal" },
          { "day": "Day 5", "text": "Local culture + departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["Santiago Grand Island Tour", "Authentic Northern Santiago"],
        "transfersNote": "Transfers included",
        "meals": "As per itinerary",
        "included": ["Accommodation", "Transfers", "Mentioned experiences", "Local support"],
        "notIncluded": ["Flights"],
        "optional": ["Traditional Fishing & Beach BBQ"],
        "important": ["Final price on request"],
      },
      "santiago-active-local": {
        "name": "Santiago Active & Local",
        "duration": "7 days",
        "style": "Active & Local",
        "idealFor": "Active travelers who want to experience the island",
        "overview": "An active and local week in Santiago: complete island tour, trekking, sea, traditional fishing, and gastronomy.",
        "highlights": ["Grand Island Tour", "Serra Malagueta Trek", "Fishing & BBQ + Cachupa"],
        "itinerary": [
          { "day": "Day 1", "text": "Arrival" },
          { "day": "Day 2", "text": "Santiago Grand Island Tour" },
          { "day": "Day 3", "text": "Serra Malagueta → Vale de Principal Trek" },
          { "day": "Day 4", "text": "Free / Beach" },
          { "day": "Day 5", "text": "Traditional Fishing & Beach BBQ" },
          { "day": "Day 6", "text": "Cachupa Cooking & Local Culture" },
          { "day": "Day 7", "text": "Departure" },
        ],
        "accommodationNote": "Selected local accommodation",
        "experiencesIncluded": ["Santiago Grand Island Tour", "Serra Malagueta → Vale de Principal Trek", "Traditional Fishing & Private Beach BBQ", "Cachupa Cooking Experience"],
        "transfersNote": "Transfers included",
        "meals": "As per itinerary (lunches on experiences)",
        "included": ["Accommodation", "Transfers", "Mentioned experiences", "Local support"],
        "notIncluded": ["Flights"],
        "optional": ["Pico de Antónia Challenge"],
        "important": ["Final price on request"],
      },
    },
    transfers: {
      "praia-tarrafal": {
        "capacities": ["1–3 passengers", "4–14 passengers"],
        "name": "Praia Airport / Praia → Tarrafal",
        "distance": "74 km",
        "time": "± 1h30",
        "vehicle": "Private transfer",
        "note": "Final price on request, depending on vehicle and number of passengers.",
        "points": [
          { "name": "Praia", "lat": 14.917, "lng": -23.509 },
          { "name": "Tarrafal", "lat": 15.276, "lng": -23.752 },
        ],
      },
    },
    destinations: {
      "sao-tome-principe": {
        "positioning": "Cocoa, tropical forest, and pristine beaches.",
        "categories": ["Culture & Nature", "Sea", "Hiking", "Accommodation", "Transfers", "Full Packages"],
        "subs": {
          "sao-tome": { "tagline": "Where the forest meets the ocean.", "cta": "Explore São Tomé", "desc": "The main island of the archipelago: tropical forests of Parque Natural do Obô, century-old cocoa roças, deserted beaches, and a vibrant Creole culture. Each experience is led by local professionals from our network." , "tags": "Nature · Culture · Cocoa"},
          "principe": { "tagline": "Nature in its purest form.", "cta": "Discover Príncipe", "desc": "UNESCO World Biosphere Reserve: untouched primary forest, hidden waterfalls, historic roças, and some of the most beautiful beaches in Africa, like the iconic Praia Banana." , "tags": "Biosphere · Beaches · Roças"},
        },
      },
      "cabo-verde": {
        "positioning": "Where the mountain meets the sea.",
        "categories": ["Hiking", "Culture", "Sea", "Gastronomy", "Accommodation", "Transfers", "Full Packages"],
        "subs": {
          "santiago": { "tagline": "Where the mountain meets the sea.", "cta": "Explore Santiago", "desc": "On Santiago island, where the mountain meets the sea: volcanic trails in Serra Malagueta, the UNESCO World Heritage Cidade Velha, artisanal fishing, and the Creole soul of Cape Verdean music." , "tags": "Mountains · Ocean · Culture"},
        },
      },
      "ghana": {
        "cta": "Discover Ghana",
        "positioning": "Culture, heritage and community tourism.",
        "categories": ["Culture & Heritage", "Local Experiences", "Nature", "Community Tourism", "Accommodation", "Transfers", "Full Packages"],
        "subs": {
        },
      },
      "kenya": {
        "cta": "Plan Kenya",
        "positioning": "Safari, wildlife and coast.",
        "categories": ["Safari", "Wildlife", "Culture", "Nature", "Coast", "Community Experiences", "Accommodation", "Transfers", "Full Packages"],
        "subs": {
        },
      },
      "tanzania": {
        "cta": "Plan Tanzania",
        "positioning": "From extraordinary landscapes to local communities and the Indian Ocean.",
        "categories": ["Safari", "Wildlife", "Nature", "Culture", "Local Communities", "Zanzibar / Coast", "Accommodation", "Transfers", "Full Packages"],
        "subs": {
        },
      },
      "mauritius": {
        "cta": "Explore Mauritius",
        "positioning": "Discover Mauritius through the people who know it best.",
        "categories": ["Island Experiences", "Beaches", "Nature", "Culture", "Gastronomy", "Boat Experiences", "Accommodation", "Transfers", "Full Packages"],
        "subs": {
        },
      },
      "maldives": {
        "cta": "Explore Maldives",
        "positioning": "Experience the Maldives beyond the postcard.",
        "categories": ["Island Stays", "Local Islands", "Resorts", "Marine Experiences", "Diving / Snorkeling", "Boat Experiences", "Transfers", "Full Packages"],
        "subs": {
        },
      },
    },
};
